import React, { ReactElement } from 'react';
import ActionButton from '../action-button/action-button.component';
import TextBlock from '../text-block/text-block.component';
import AddNewItemIcon from '../../icons/add-new-item-icon';
import FormatService from '../../services/format-service';
import useStylesActionButtonNewItem from './action-button-new-item.styles';

const ActionButtonNewItem: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const COLOR_SECONDARY: ThemeColor = 'secondary';
  const LABEL_DEFAULT: string = 'Add New Line';

  const {
    isLight,
    withNoLabel,
    withNoPadding,
    withNoHighlight,
    withTopOffset,
    label,
    className,
    onClick,
  } = props;

  const { classes } = useStylesActionButtonNewItem();

  const noPaddingClassName: string | undefined = withNoPadding ? classes.actionButtonNewItemNoPadding : undefined;
  const noHighlightClassName: string | undefined = withNoHighlight
    ? classes.actionButtonNewItemNoHighlight : undefined;
  const labelClassName: string | undefined = !withNoLabel ? classes.actionButtonNewItemLabel : undefined;
  const topOffsetClassName: string | undefined = withTopOffset ? classes.actionButtonNewItemTopOffset : undefined;
  const textBlockLightClassName: string | undefined = isLight ? classes.textBlockLight : undefined;

  return (
    <ActionButton
      withNoRipple
      isLight={isLight}
      color={COLOR_SECONDARY}
      className={FormatService.formatClassNames(
        classes.actionButtonNewItem, noPaddingClassName, noHighlightClassName, labelClassName, topOffsetClassName,
        className,
      )}
      onClick={onClick}
    >
      <AddNewItemIcon className={classes.icon} />
      {
        !withNoLabel && (
          <TextBlock className={textBlockLightClassName}>
            {label || LABEL_DEFAULT}
          </TextBlock>
        )
      }
    </ActionButton>
  );
});

export default ActionButtonNewItem;
